import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ControlePatrimonio } from "../../models/controle_patrimonio";
import { IGetControlePatrimoniosUseCase } from "../../../presentation/useCases/read/get_controle_patrimonios_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetControlePatrimoniosUseCase
 */

export class GetControlePatrimoniosUseCase extends BasePaginatedUseCase<ControlePatrimonio> implements IGetControlePatrimoniosUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getControlePatrimonios(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getControlePatrimonios(
      idFuncionario,
      page,
      pageSize,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}